import { DependencyList, EffectCallback, useEffect } from 'react';

export function useAsyncEffect(effect: EffectCallback | (() => Promise<any>), deps?: DependencyList): void {
    useEffect(() => {
        let result = effect();
        if (result instanceof Promise) {
            return;
        }
        return result;
    }, deps);
}
